<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.error.title.maintenance")}}</h1>
        <br>
        {{$t("message.error.desc.maintenance")}}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RedirectMixin from '@/mixins/redirect'

export default {
  name: 'maintenance',
  components: {},
  data: () => ({}),
  computed: {
  },
  mixins: [RedirectMixin],
  methods: {},
  created: function () {}
}
</script>
